import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  TextField,
  Grid,
  Typography,
  Button,
  IconButton,
  Collapse,
} from '@material-ui/core';
import {
  ArrowBack
} from '@material-ui/icons';
import Alert from '@material-ui/lab/Alert';
import { RegisterForm } from './styles';
import { saveBoard } from './services.js';

const Register = () => {
  const [name, setName] = useState();
  const [link, setLink] = useState();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  const resetBoard = () => {
    setName('');
    setLink('');
    setWidth('');
    setHeight('');
  }

  const registerBoard = async () => {
    setError('');
    try {
      await saveBoard({
        name,
        link,
        width: +width,
        height: +height
      });
      setSuccess(true);
      resetBoard();
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    } catch(e) {
      setError(e.message);
    }
  }

  return (
    <RegisterForm>
      <Grid container spacing={2} style={{ alignItems: 'center' }}>
        <Grid item>
          <IconButton component={Link} to="/admin">
            <ArrowBack />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography variant="h5">
            Adicionar Board
          </Typography>
        </Grid>
      </Grid>
      <TextField
        label="Nome"
        variant="outlined"
        fullWidth
        margin="normal"
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <TextField
        label="Link"
        variant="outlined"
        fullWidth
        margin="normal"
        value={link}
        onChange={e => setLink(e.target.value)}
      />
      <Grid container spacing={2} style={{ alignItems: 'center' }}>
        <Grid item xs={5}>
          <TextField
            label="Largura"
            variant="outlined"
            fullWidth
            margin="normal"
            value={width}
            onChange={e => setWidth(e.target.value)}
            type="number"
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label="Altura"
            variant="outlined"
            fullWidth
            margin="normal"
            value={height}
            onChange={e => setHeight(e.target.value)}
            type="number"
          />
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h6">
            cm
          </Typography>
        </Grid>
      </Grid>
      <Button variant="contained" color="primary" style={{ marginTop: 16, marginBottom: 16 }} onClick={registerBoard}>
        Salvar
      </Button>
      <Collapse in={success}>
        <Alert severity="success">Board salvo com sucesso!</Alert>
      </Collapse>
      <Collapse in={error}>
        <Alert severity="error">{error}</Alert>
      </Collapse>
    </RegisterForm>
  )
}

export default Register;
